import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuthentication } from '@/hooks/useAuthentication';
import Routes from './router/routes';

export default function App() {
  const navigate = useNavigate();
  // skipAutoRedirect: true so the hook's own auto-redirect useEffect doesn't
  // race with us, and so processAuthSuccess doesn't navigate internally —
  // App.tsx owns navigation in this flow.
  const { processAuthSuccess } = useAuthentication({ skipAutoRedirect: true });
  const token = Cookies.get('token');
  const main_organization = Cookies.get('main_organization');
  const main_workspace = Cookies.get('fallback_workspace');

  useEffect(() => {
    // Fast path: all cookies present → navigate directly.
    if (token && main_organization && main_workspace) {
      navigate(
        `${Routes.organization.path}/${main_organization}${Routes.workspace.path}/${main_workspace}`,
      );
      return;
    }
    // No token → straight to login.
    if (!token) {
      navigate(Routes.login.path);
      return;
    }
    // TELV1-278: Token cookie present but workspace context cookie missing.
    // Previously this fell through to `return null` → blank screen. Re-resolve
    // via the existing login flow: fetches user orgs, finds a valid one,
    // computes mainWorkspace, re-writes the missing cookies, and returns the
    // resolved org/workspace IDs. We navigate based on the result.
    // Falls back to /login if re-resolve fails (invalid token, no valid org).
    processAuthSuccess(token).then((result) => {
      if (result.success && result.currentOrganization && result.currentWorkspace) {
        navigate(
          `${Routes.organization.path}/${result.currentOrganization}${Routes.workspace.path}/${result.currentWorkspace}`,
        );
      } else {
        navigate(Routes.login.path);
      }
    });
  }, [navigate, token, main_organization, main_workspace, processAuthSuccess]);

  return null;
}
